import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
const RaisingDay = () => {
  useEffect(() => {
    document.title = "Raising Day -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Raising Day</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Raising Day </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/RaisingDay.jpg"
                  className="img-fluid raisinday"
                  alt="The Air Force School"
                />
              </LazyLoad>
            </div>
            <div className="col-lg-8">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/RaisingDay1.jpg"
                  className="img-fluid mt-2 raisinday"
                  alt="The Air Force School"
                />
              </LazyLoad>
            </div>
            <div className="col-lg-6">
              <br />
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/RaisingDay2.jpg"
                >
                  <img
                    style={{ border: "5px double #ccc" }}
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/RaisingDay2.jpg"
                    className="img-fluid rounded p-1"
                    alt="The Air Force School"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-6">
              <br />
              <iframe
                width="100%"
                height="450"
                src="https://www.youtube.com/embed/7P0Fc8kT3wA?autoplay=1&mute=1"
                title="YouTube video player"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              ></iframe>
            </div>
            <div className="col-lg-12">
              <div className="RaisingDaybox">
                <p>
                  {" "}
                  <b>Dear Parents </b>
                </p>
                <p>
                  {" "}
                  We would like to extend our heartfelt thanks for your
                  incredible support in making Raising Day a great success. Your
                  involvement and enthusiasm truly make this event
                  memorable.{" "}
                </p>
                <p>
                  {" "}
                  We are pleased to share that our Raising Day was covered by
                  various news channels and news papers.{" "}
                </p>
                <p> Below are the few links to the coverage: </p>
                <h6>DD NEWS </h6>
                <Link to="https://youtube.com/shorts/7P0Fc8kT3wA?si=rzO7c-pE8IhM85S1">
                  {" "}
                  https://youtube.com/shorts/7P0Fc8kT3wA?si=rzO7c-pE8IhM85S1{" "}
                </Link>
                <h6>ANI NEWS </h6>
                <Link to="https://www.youtube.com/watch?v=rlnvsyQW4a4">
                  {" "}
                  https://www.youtube.com/watch?v=rlnvsyQW4a4
                </Link>
                <h6>Republic World </h6>
                <Link to="https://www.youtube.com/watch?v=766SLDZgDhU">
                  {" "}
                  https://www.youtube.com/watch?v=766SLDZgDhU
                </Link>
                <h6>DD INDIA </h6>
                <Link to="https://www.youtube.com/watch?v=Gbq7BbeL5C8">
                  {" "}
                  https://www.youtube.com/watch?v=Gbq7BbeL5C8
                </Link>
                <h6>TOI Bharat </h6>
                <Link to="https://www.youtube.com/watch?v=KDlP5EW_a7A">
                  {" "}
                  https://www.youtube.com/watch?v=KDlP5EW_a7A{" "}
                </Link>
                <h6>India Today </h6>
                <Link to="https://www.youtube.com/shorts/6LkYZ8ZmhpE">
                  {" "}
                  https://www.youtube.com/shorts/6LkYZ8ZmhpE{" "}
                </Link>
                <h6>The Tribune </h6>
                <Link to="https://www.youtube.com/watch?v=1SojQP076hg">
                  {" "}
                  https://www.youtube.com/watch?v=1SojQP076hg{" "}
                </Link>
                <h6>Business Today </h6>
                <Link to="https://www.youtube.com/watch?v=XR-Gm9IWsKM">
                  {" "}
                  https://www.youtube.com/watch?v=XR-Gm9IWsKM{" "}
                </Link>
                <h6>NDTV </h6>
                <Link to="https://www.youtube.com/watch?v=m8mjDMifIzc">
                  {" "}
                  https://www.youtube.com/watch?v=m8mjDMifIzc{" "}
                </Link>
                <p>
                  {" "}
                  <b>Link to News Articles:</b>
                </p>
                <h6> Hindustan Times </h6>
                <Link to="https://www.hindustantimes.com/india-news/jaishankar-shares-life-lessons-with-youth-says-tonegotiate-you-have-to-outthink-your-competitors-101752843150732.html">
                  {" "}
                  https://www.hindustantimes.com/india-news/jaishankar-shares-life-lessons-with-youth-says-tonegotiate-you-have-to-outthink-your-competitors-101752843150732.html
                </Link>
                <h6> Times of India </h6>
                <Link to="https://timesofindia.indiatimes.com/videos/news/we-went-into-ukraine-eam-jaishankars-key-remarks-at70th-raising-day-ceremony-of-tafs-delhi/videoshow/122764558.cms">
                  {" "}
                  https://timesofindia.indiatimes.com/videos/news/we-went-into-ukraine-eam-jaishankars-key-remarks-at70th-raising-day-ceremony-of-tafs-delhi/videoshow/122764558.cms
                </Link>
                <h6> Business Today </h6>
                <Link to="https://www.businesstoday.in/amp/bt-tv/video/world-has-entered-our-homes-jaishankar-urges-studentsto-embrace-global-change-ai-geopolitics-485295-2025-07-18">
                  {" "}
                  https://www.businesstoday.in/amp/bt-tv/video/world-has-entered-our-homes-jaishankar-urges-studentsto-embrace-global-change-ai-geopolitics-485295-2025-07-18{" "}
                </Link>
                <h6> The Statesman </h6>
                <Link to="https://www.thestatesman.com/india/at-alma-mater-eam-jaishankar-urges-students-to-embrace-learningand-self-discovery-1503459465.html#google_vignette">
                  {" "}
                  https://www.thestatesman.com/india/at-alma-mater-eam-jaishankar-urges-students-to-embrace-learningand-self-discovery-1503459465.html#google_vignette{" "}
                </Link>
                <h6> Amar Ujala </h6>
                <Link to="https://www.amarujala.com/education/it-is-wonderful-to-be-back-where-i-did-most-of-my-educationforeign-minister-on-70th-foundation-day-of-tafs-2025-07-18">
                  {" "}
                  https://www.amarujala.com/education/it-is-wonderful-to-be-back-where-i-did-most-of-my-educationforeign-minister-on-70th-foundation-day-of-tafs-2025-07-18{" "}
                </Link>
                <h6> Awaaz The Voice </h6>
                <Link to="https://www.awazthevoice.in/india-news/take-best-from-school-avoid-stress-eam-shares-key-advice-atair-force-school-39260.html">
                  {" "}
                  https://www.awazthevoice.in/india-news/take-best-from-school-avoid-stress-eam-shares-key-advice-atair-force-school-39260.html{" "}
                </Link>
                <h6> News.abp </h6>
                <Link to="https://news.abplive.com/news/india/air-force-school-rising-day-eam-jaishankar-shares-key-advice-takebest-avoid-stress-1788811">
                  {" "}
                  https://news.abplive.com/news/india/air-force-school-rising-day-eam-jaishankar-shares-key-advice-takebest-avoid-stress-1788811{" "}
                </Link>
                <p>
                  {" "}
                  Thank you once again for your continued support. We look
                  forward to more successful events in the future.{" "}
                </p>
                <p>
                  {" "}
                  <b>
                    Warm Regards, <br />
                    Principal
                  </b>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RaisingDay;
